export const styles = {
  modal: {
    overlay: "fixed inset-0 z-[99] flex items-center justify-center bg-opacity-5 bg-black/20 w-full h-full",
    container: "bg-white rounded-md w-[722px]",
    header: "bg-[#0F5BF1] py-3 pl-[282.5px] pr-[33px] rounded-t-md flex justify-between items-center",
    title: "text-2xl font-sans text-white font-semibold",
    closeBtn: "hover:transform hover:scale-110 transition-transform",
    body: "flex flex-col items-center justify-center gap-10 px-[33px] pt-[36px] pb-[138.57px]",
    sectionTitle: "font-sans text-xl font-semibold text-center self-stretch"
  },
  tabs: {
    wrapper: "flex justify-center gap-4",
    base: "px-4 py-[9.75px] rounded-md flex gap-3 items-center border transition-colors",
    active: "bg-black text-white",
    inactive: "bg-[#F1F4FF] text-[#282A30] hover:bg-black hover:text-white"
  },
  email: {
    input: "flex flex-1 border p-2 rounded-md justify-between items-center",
    addButton: "bg-[#023496] text-white p-2 rounded-md disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer",
    note: "text-xs text-red-100",
    error: "text-xs text-red-100"
  },
  mobile: {
    input: "flex flex-1 border p-2 rounded-md justify-between items-center",
    removeBtn: "w-5 h-5 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200",
    addBtn: "bg-[#023496] text-white p-2 rounded-md disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer",
    hint: "text-[#61758A] text-xs font-normal pl-1",
    error: "text-[#960202] text-xs font-normal pl-1"
  },
  buttons: {
    send: "w-full mt-4 bg-blue-600 text-white py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
  },
  message: {
    base: "p-2 rounded text-sm flex items-center text-center",
    success: "bg-[#E3FCEF] text-[#000]",
    error: "bg-[#FCE3E3] text-[#000]"
  }
};
